import React from 'react';
import { Link } from 'react-router-dom';
import './ServicesSection.css';

const services = [
  {
    icon: '👤',
    title: 'Individual Tax Services',
    items: ['W2 Tax Filing', '1099 / Self-Employed (Uber, Lyft, CNA)', 'Amended Returns (1040X)', 'ITIN Applications'],
  },
  {
    icon: '🏢',
    title: 'Business Tax Services',
    items: ['LLC & Small Business Filing', 'Trucking Business Taxes', 'Schedule C Optimization', 'Quarterly Estimated Taxes'],
  },
  {
    icon: '🛠️',
    title: 'Special Services',
    items: ['IRS Letter Help (CP2000, Audits)', 'Refund Maximization Strategy', 'Tax Planning', 'Back Tax Filing'],
  },
  {
    icon: '🚗',
    title: 'Gig Economy Taxes',
    items: ['Uber & Lyft Driver Taxes', 'DoorDash / Instacart Filing', 'Freelancer Tax Returns', 'Home Office Deductions'],
  },
  {
    icon: '💰',
    title: 'Refund Maximization',
    items: ['Child Tax Credit Review', 'EITC Eligibility Check', 'Education Credits', 'Deduction Finder Analysis'],
  },
  {
    icon: '⚖️',
    title: 'IRS Resolution',
    items: ['Audit Representation', 'CP2000 Notice Response', 'Payment Plan Assistance', 'Tax Lien Help'],
  },
];

const ServicesSection = () => (
  <section className="section section-alt" id="services">
    <div className="container">
      <div className="section-header">
        <div className="section-label">What We Offer</div>
        <h2 className="section-title">
          We Run All Kinds of Tax Services in the Form of{' '}
          <em>Information &amp; Excellence</em>
        </h2>
        <p className="section-subtitle">
          From simple W-2 filings to complex business taxes, we've got you covered —
          fast, accurate, and maximizing every dollar.
        </p>
      </div>
      <div className="services-grid">
        {services.map((s) => (
          <div className="service-card" key={s.title}>
            <div className="service-icon">{s.icon}</div>
            <h3>{s.title}</h3>
            <ul className="service-list">
              {s.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <Link to="/contact" className="service-link">
              Learn More →
            </Link>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesSection;
